import { useEffect } from "react";
import { navigate } from "@reach/router";

/**
 * redirects from old urls:
 * 	account/request-for-quote/497/returnable-schedules
 *
 * to:
 * 	account/rfx/497/returnable-schedules
 *
 * @param param0
 * @returns
 */
const GuestRfxSubmissionRedirect: React.FC<{
	path: string;
	currentTab?: string;
	rfxId?: number;
}> = ({ currentTab, rfxId, path }) => {
	useEffect(() => {
		if (!rfxId) {
			return;
		}

		let redirectPath = `/account/rfx/${rfxId}/submission/`;

		if (currentTab) {
			redirectPath += `${currentTab}/`;
		}

		navigate(redirectPath, {
			replace: true,
		});
	}, [currentTab, rfxId]);

	return null;
};

export default GuestRfxSubmissionRedirect;
